import { Injectable } from "@angular/core";
import { Adapter } from "src/app/core/adapter";
import { Model } from "src/app/core/models/model";

export enum OrderByDirection {
  asc = "asc",
  desc = "desc",
}
export interface OrderByItem {
  id: string;
  field: string;
  direction: OrderByDirection;
  label: string;
}

export enum ResultType {
  showerhead = "showerhead",
  meter = "meter",
  place = "place",
}

export class SearchResult implements Model {
  public get isPlace() {
    return this.type == ResultType.place;
  }

  public get isMeter() {
    return this.type == ResultType.meter;
  }

  constructor(
    public id: string,
    public type: ResultType,
    public label: string,
    public serial: string
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class SearchResultAdapter implements Adapter<SearchResult> {
  constructor() {}
  adapt(item: any): SearchResult {
    return new SearchResult(
      item.id,
      item.type as ResultType,
      item.label,
      item.serial
    );
  }
}
